// extracted by mini-css-extract-plugin
export var card = "_n7-1";
export var summary = "_n7-0";
export var unreadDot = "_n7-2";